import Modal from './Modal'

/**
 * Bevestiging vóór een registratie die de voorraad onder 0 brengt. Alleen in
 * beeld als de instelling 'Voorraad mag negatief worden' aanstaat; zonder die
 * instelling wordt de registratie geweigerd en verschijnt `StockWarningModal`.
 *
 * @typedef {object} NegativeStockWarning
 * @property {string} MaterialID - Materials.ID
 * @property {string} Title - Naam van het materiaal
 * @property {number} Required - Aantal dat wordt afgeboekt
 * @property {number} Available - Voorraad vóór de mutatie
 * @property {number} Resulting - Voorraad ná de mutatie (negatief)
 *
 * @param {object} props
 * @param {boolean} props.modalOpen - Of het venster open staat
 * @param {(open: boolean) => void} props.setModalOpen - Sluit het venster
 * @param {Array<NegativeStockWarning>} props.warnings - Materialen die in de min komen
 * @param {() => void} props.confirm - Doorgaan met registreren
 */
const NegativeStockConfirmModal = ({ modalOpen, setModalOpen, warnings, confirm }) => {
    const items = warnings || []

    const content = (
        <div className='subtask-stock-warning'>
            <p>
                {items.length === 1
                    ? 'Dit brengt de voorraad van dit materiaal in de min:'
                    : 'Dit brengt de voorraad van deze materialen in de min:'}
            </p>
            <ul>
                {items.map((warning) => (
                    <li key={warning.MaterialID}>
                        <strong>{warning.Title || 'Materiaal'}</strong> — nodig: {warning.Required},
                        beschikbaar: {warning.Available}, wordt: {warning.Resulting}
                    </li>
                ))}
            </ul>
            <p>Weet je zeker dat je wilt doorgaan?</p>
        </div>
    )

    return (
        <Modal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            pageHeader='Voorraad komt in de min'
            content={content}
            confirm={confirm}
            confirmLabel='Toch registreren'
        />
    )
}

export default NegativeStockConfirmModal
